import mitt, { type Emitter } from 'mitt';
import type { ITransitionData } from '@barba/core/dist/core/src/src/defs';
import type barba from '@barba/core';
import type {PlatformCart} from "@/js/shopify/types";

type Events = {
  barba_leave: ITransitionData;
  barba_enter: ITransitionData;
  barba_after: ITransitionData;
  barba_ready: typeof barba;cart: PlatformCart;
  cartToggle: void;
  menuToggle: void;
  busy: boolean;
  cancel: void;
  click: MouseEvent;
  mousemove: {x: number ,y: number };
  keydown: KeyboardEvent;
  error: CustomEvent;
  scroll: number;
  resize: void;
  on_top: void;
  paginate: HTMLElement;
};

export const bus: Emitter<Events> = mitt<Events>();
window.addEventListener('click', (ev) => {
  bus.emit('click', ev);
});

window.addEventListener('keydown', (ev) => {
  bus.emit('keydown', ev);
  if (ev.key === 'Escape') {
    bus.emit('cancel');
  }
});

document.body.addEventListener('error', (e: CustomEvent) => {
  bus.emit('error', e);
});

let scheduledAnimationFrame1 = false;
let scheduledAnimationFrame2 = false;

function onScroll() {
  if (scheduledAnimationFrame1) {
    return;
  }

  scheduledAnimationFrame1 = true;
  requestAnimationFrame(() => {
    bus.emit('scroll', window.scrollY);
    scheduledAnimationFrame1 = false;
  });
}

window.addEventListener('scroll', onScroll);

function onResize() {
  if (scheduledAnimationFrame2) {
    return;
  }

  scheduledAnimationFrame2 = true;
  requestAnimationFrame(() => {
    bus.emit('resize');
    scheduledAnimationFrame2 = false;
  });
}

window.addEventListener('resize', onResize);
